import { useSubjectThemeKey } from '@educator/hooks/useSubjectThemeKey'
import { SubjectLoadingScreen } from '@mc/educator-design-system'
import { useTranslation } from '@mc/i18n'

// Full-screen loading state shown the instant a topic is opened, while the next
// page's server props and dialog history load. It plays the square animation for
// the subject the lesson belongs to, with a "Loading your lesson" caption, so
// the modal → chat hand-off feels like the lesson is already opening instead of
// a click that hangs on the previous screen.
//
// `subjectSlug` comes from the destination lesson route
// (/learning/subjects/<subject>/modules/...).
export const ChatLoadingScreen = ({
  subjectSlug,
}: {
  subjectSlug?: string
}) => {
  const { t } = useTranslation('@mc/educator')
  const themeKey = useSubjectThemeKey(subjectSlug)

  return (
    <div className='tailwind-enabled h-full w-full bg-edu-bg-primary'>
      <SubjectLoadingScreen
        subjectSlug={themeKey}
        label={t('executiveChat.loadingLesson')}
      />
    </div>
  )
}
